export enum FormQuestionType {
  TEXT = 'text',
  RATING = 'rating',
}
